<script lang="ts" setup>
import { useLocale } from "vuetify"; // TODO: OBSOLETE.

const { current, t } = useLocale();
</script>

<template>
  <section>
    <s-header
      background="/images/general/blue-banner.webp"
      :image='t("ourSuccesses.titleImage")'
      :title='t("ourSuccesses.title")'>
    </s-header>
    <!-- companies -->
    <div
      class='
        flex flex-col'>
      <s-success
        v-for='c in t("ourSuccesses.companies").split(",")'
        :intro="t(`ourSuccesses.${c}.intro`)"
        :description="t(`ourSuccesses.${c}.description`)"
        :shortdescription="t(`ourSuccesses.${c}.shortdescription`)"
        :id="c"
        :key="c"
        :logo="t(`ourSuccesses.${c}.logo`)"
        :headerImage="t(`ourSuccesses.${c}.headerImage`)"
        :mobileHeaderImage="t(`ourSuccesses.${c}.mobileHeaderImage`)"
        :gps-lat="parseFloat(t(`ourSuccesses.${c}.gpsLat`))"
        :gps-lng="parseFloat(t(`ourSuccesses.${c}.gpsLng`))"
        :title="t(`ourSuccesses.${c}.title`)"
        :mobileTitle="t(`ourSuccesses.${c}.mobileTitle`)"
        :showMarker="t(`ourSuccesses.${c}.showMarker`) !== 'false'"
        :marker_title_ar="t(`ourSuccesses.${c}.marker_title_ar`)"
        :marker_title_en="t(`ourSuccesses.${c}.marker_title_en`)"
        :website="t(`ourSuccesses.${c}.website`)">
      </s-success>
    </div>
  </section>
</template>

<style scoped>
h3
{
  @apply
    text-xl font-semibold text-center
    max-md:text-white max-md:bg-black/30
    md:inline-block
    md:px-8 py-2.5 md:py-1
    md:mx-[20%] md:mt-[20%]
    uppercase
    md:border-[1px] md:rounded-sm;
}
</style>
